import { Component, Input, AfterContentInit } from '@angular/core';
import { ButtonColorsEnum } from '../../../shared/models/enums/ButtonColorsEnum';

declare let require: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterContentInit {
  protected readonly locationbar = locationbar;
  public readonly ButtonColorsEnum = ButtonColorsEnum;

  constructor() {
    setInterval(() => {
      this.bounce = this.bounce < 3 ? this.bounce + 1 : 1;
    }, 3000);

    setTimeout(() => this.start = true, 1000);
  }
  @Input() themeType: string;

  public param = {title: 'Koodan'};
  public bounce: number = 1;
  start: boolean = false;

  ngAfterContentInit(): void {
    setTimeout(() => {
      const Parallax = require('parallax-js');
      const scene = document.getElementById('scene');
      const parallaxInstance1 = new Parallax(scene, {
        relativeInput: false
      });
    }, 2000);
  }

  scrollTo(section): void {
    const sectionHtml = document.querySelector('#' + section);
    if (sectionHtml !== null) {
      sectionHtml.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }
}
